<template>
  <v-dialog
    v-model="isOpen"
    max-width="350"
    @click:outside.prevent="closeTaskDocumentTypesModal"
  >
    <v-card class="pa-5">
      <v-btn icon color="black" absolute top right @click="closeTaskDocumentTypesModal">
        <v-icon>$close</v-icon>
      </v-btn>
      <h3 class="text-center mb-10">Document types</h3>
      <div class="mb-5">
        <v-card
          v-for="type in taskDocumentTypes"
          :key="type.id"
          class="pa-0 d-flex justify-space-between align-center elevation-0 mb-3"
        >
          <v-col cols="10" class="pa-0">
            <v-text-field
              v-model="type.value"
              single-line
              solo
              v-on:change="documentTypeChangeHandler(type)"
              height="20"
              :loading="type.isUpdating">
            </v-text-field>
          </v-col>
          <div>
            <v-btn fab small primary="transparent" class="elevation-0" :loading="delBtnLoading && cardClicked === type.id" @click="deleteTaskDocumentType(type)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </v-card>
      </div>
      <v-form ref="taskDocumentTypeForm" lazy-validation>
        <v-flex xs12 class="d-flex align-center">
          <v-text-field
            v-model="title"
            placeholder="Document type name"
            :rules="titleRules"
            value="true"
            required="false"
            autocomplete="off"
          ></v-text-field>
          <v-btn color="primary" @click="addDocumentTypeHandler" :loading="btnLoading" class="ml-5">Add</v-btn>
        </v-flex>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import validationRules from '@/common/validationRules'
  export default {
    name: 'TaskDocumentTypesManage',
    props: ['isOpen', 'closeTaskDocumentTypesModal'],
    data: () => ({
      title: '',
      titleRules: validationRules.titleShort,
      btnLoading: false,
      delBtnLoading: false,
      cardClicked: null
    }),
    computed: {
      ...mapGetters({
        taskDocumentTypes: 'getDocumentTypes'
      })
    },
    methods: {
      async addDocumentTypeHandler () {
        if (this.$refs.taskDocumentTypeForm.validate()) {
          this.btnLoading = true
          const result = await this.$store.dispatch('addDocumentType', this.title)
          if (result) {
            this.btnLoading = false
            this.title = ''
          }
          this.btnLoading = false
        }
      },
      async documentTypeChangeHandler (type) {
        await this.$store.dispatch('updateDocumentType', type)
      },
      async deleteTaskDocumentType (type) {
        this.cardClicked = type.id
        if (await this.$root.$confirmDialog.open(type.value, null, "The tasks assigned to this Document type will be unassigned and disappear from User's documents. Are you sure you want to delete the Document type?")) {
          this.delBtnLoading = true
          await this.$store.dispatch('deleteDocumentType', type.id)
          this.delBtnLoading = false
        }
        this.cardClicked = null
      }
    }
  }
</script>
